module.exports = __webpack_public_path__ + "static/media/207.abb43423.wav";